import styled from 'styled-components';

const AvatarsContainer = styled.div`
  display: flex;
  width: auto;
  align-items: center;
  justify-content: center;
`;

export default AvatarsContainer;
